import React from 'react';
import SectionHeader from './SectionHeader';
import { DIRECTOR } from '../mock';

export default function Director() {
  return (
    <section id="director" className="section-pad">
      <div className="container-narrow">
        <SectionHeader chapter={DIRECTOR.chapter} label={DIRECTOR.label} heading={DIRECTOR.heading} />
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="absolute -inset-3 bg-[radial-gradient(ellipse_at_center,rgba(200,161,74,0.18),transparent_70%)] blur-2xl" />
              <div className="relative border border-[color:var(--bx-gold)]/30 p-3">
                <img src={DIRECTOR.img} alt="Anl Arasu" className="w-full h-auto block" style={{ filter: 'grayscale(0.2) contrast(1.05)' }} />
              </div>
              <div className="mt-3 font-sc text-[10px] gold-text tracking-[0.4em]">{DIRECTOR.role}</div>
            </div>
          </div>
          <div className="lg:col-span-7">
            <div className="grid grid-cols-3 gap-px bg-[color:var(--bx-gold)]/20 mb-8">
              {DIRECTOR.meta.map((m, i) => (
                <div key={i} className="bg-[#0b0908] p-5">
                  <div className="font-sc text-[10px] gold-text tracking-[0.4em] mb-1">{m.k}</div>
                  <div className="font-serif text-[16px] text-[color:var(--bx-bone)]/90">{m.v}</div>
                </div>
              ))}
            </div>
            <div className="space-y-5 mb-10">
              {DIRECTOR.paragraphs.map((p, i) => (
                <p key={i} className="font-serif text-[18px] leading-[1.75] text-[color:var(--bx-bone)]/85">{p}</p>
              ))}
            </div>
            <div>
              <div className="font-sc text-[10px] gold-text tracking-[0.42em] mb-4">SELECTED FILMOGRAPHY</div>
              <ul className="divide-y divide-[color:var(--bx-gold)]/15 border-y border-[color:var(--bx-gold)]/15">
                {DIRECTOR.films.map((f, i) => (
                  <li key={i} className="flex items-center justify-between py-3">
                    <span className="font-serif text-[19px] text-[color:var(--bx-bone)]">{f.t}</span>
                    <span className="font-sc text-[10px] gold-text tracking-[0.4em]">{f.r}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-16 text-center">
          <div className="font-sc text-[10px] gold-text tracking-[0.4em] mb-2">A FILM BY</div>
          <div className="heading-xl text-3xl md:text-4xl text-gold-orange">ANL ARASU</div>
          <div className="font-sc text-[10px] text-[color:var(--bx-muted)] tracking-[0.4em] mt-4">{DIRECTOR.footer}</div>
        </div>
      </div>
    </section>
  );
}
